// extracted by mini-css-extract-plugin
export default {"ImagesSection":"SingleProduct_ImagesSection__duJJo","prodctsImages":"SingleProduct_prodctsImages__UFChK"};